import axios from "axios";
import {baseUrlCatalog, xApiKeyCatalog} from "../../config/api/apiConfig";

const companyCode = 'amarta';

class CatalogOpenSearchServices {
    private axios = axios.create({
        baseURL: baseUrlCatalog,
    });

    private axios2 = axios.create({
        baseURL: "https://asia-southeast2-ideal-trimitra.cloudfunctions.net",
    });

    public async getCatalogSearch(params: any) {
        const queries = {
            variant_code: params?.variantCode,
            search_text: params?.searchText,
            search_color: params?.searchColor,
            otr: params?.otr,
            active: "true"
        }

        try {
            return await this.axios.get<any>(`/search/${companyCode}/${params?.cityGroup}`, {
                headers: {
                    "X-Api-Key": xApiKeyCatalog,
                },
                params: {
                    ...queries,
                }
            });
        } catch (e: any) {
            throw new Error(e?.response?.data?.error?.message);
        }
    }

    public async openSearchFeedBack(inputData?: any) {
        return {
            success: true,
            data: 'unused open search service'
        }

        // try {
        //     return await this.axios2.post<any>('/api-open-search/search-mark-relevant',
        //         inputData, {
        //             headers: {
        //                 "Content-Type": "application/json",
        //                 "X-Api-Key": ""
        //             }
        //         });
        // } catch (e: any) {
        //     throw new Error(e?.response?.data);
        // }
    }

}

export const catalogOpenSearchServices = new CatalogOpenSearchServices();
